import { Res, TicketLineDTO, Permission, SoldProductType } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as SalesStore from '../SalesStore';
import { Command } from 'pos/common';
import { CustomerDisplay } from 'pos/services';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		inviteTicketLine: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('inviteTicketLine', Preconditions.ensure(Permission.Ticket_InviteLine), async (line: TicketLineDTO): Promise<Result> => {
	if (line.Type === SoldProductType.MenuItem) {
		await Message.show(Res.Msg.MSG_CANNOT_INVITE_A_MENU_ITEM_LINE());
		return Result.error();
	}

	await SalesStore.inviteLine(line.Id);
	await CustomerDisplay.displayLineDiscountPercentage(SalesStore.getTicket(), SalesStore.getLineById(line.Id));
	return Result.ok();
});